import { Component, computed, inject, signal, ChangeDetectionStrategy } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { AsyncTasksStore } from "@fry/async-tasks/lib/async-tasks.store";
import { EasTableRow } from "@fry/lib/store";
import { LoadingComponent } from "@fry/ui-material/loading";
import { AlertComponent } from "@fry/ui-material/alert";
import { FryCommonModule } from "@fry/components/common";

interface AsyncTaskUndoModalData {
  row: EasTableRow;
  context: any;
}

interface UndoAction {
  itemId: string;
  taskId: string;
}

@Component({
  selector: "eas-async-task-undo-modal",
  templateUrl: "async-task-undo-modal.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FryCommonModule, MatDialogModule, MatButton, LoadingComponent, AlertComponent],
})
export class AsyncTaskUndoModalComponent {
  private store = inject(AsyncTasksStore);
  dialogRef = inject(MatDialogRef<AsyncTaskUndoModalComponent>);
  data: AsyncTaskUndoModalData = inject(MAT_DIALOG_DATA);

  $row = computed(() => this.data.row);
  $undoAction = computed<UndoAction | null>(() => this.$row()?.row?.undoAction ?? null);
  $operationInProgress = signal(false);
  $error = signal<string | null>(null);
  $success = signal(false);

  onUndo() {
    const undoAction = this.$undoAction();
    if (!undoAction || !undoAction.taskId || !undoAction.itemId) {
      this.$error.set($localize`Invalid undo action data`);
      return;
    }

    this.$operationInProgress.set(true);
    this.$error.set(null);

    this.store.undo(undoAction.taskId, undoAction.itemId).subscribe({
      next: () => {
        this.$operationInProgress.set(false);
        this.$success.set(true);
      },
      error: (err) => {
        this.$operationInProgress.set(false);
        this.$error.set(err.toString());
      },
    });
  }

  onCancel() {
    this.dialogRef.close(this.$success());
  }
}
